import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import Layout from './components/Layout.jsx';

// Pages
import Login from './pages/Login.jsx';
import MembersList from './pages/members/MembersList.jsx';
import MembersListNext from './pages/members/MembersListNext.jsx';
import MemberCard from './pages/members/MemberCard.jsx';
import MemberCardNext from './pages/members/MemberCardNext.jsx';
import ExamsList from './pages/exams/ExamsList.jsx';
import ExamsListNext from './pages/exams/ExamsListNext.jsx';
import ExamCard from './pages/exams/ExamCard.jsx';
import ExamCardNext from './pages/exams/ExamCardNext.jsx';
import KolelsList from './pages/kolels/KolelsList.jsx';
import KolelsListNext from './pages/kolels/KolelsListNext.jsx';
import KolelCard from './pages/kolels/KolelCard.jsx';
import KolelCardNext from './pages/kolels/KolelCardNext.jsx';
import AuditLogList from './pages/audit/AuditLogList.jsx';
import AuditLogListNext from './pages/audit/AuditLogListNext.jsx';
import FeatureFlags from './pages/featureFlags/FeatureFlags.jsx';
import FeatureFlagsNext from './pages/featureFlags/FeatureFlagsNext.jsx';
import EmailDomainPage, { EmailDomainPageNext } from './pages/emailDomain/EmailDomainPage.jsx';
import EmailAutomationsPage, { EmailAutomationsPageNext } from './pages/emailAutomations/EmailAutomationsPage.jsx';
import Reports from './pages/reports/Reports.jsx';
import ReportsNext from './pages/reports/ReportsNext.jsx';
import Content from './pages/content/Content.jsx';
import ContentNext from './pages/content/ContentNext.jsx';
import Subscriptions from './pages/subscriptions/Subscriptions.jsx';
import SubscriptionsNext from './pages/subscriptions/SubscriptionsNext.jsx';
import RolesPermissions from './pages/roles/RolesPermissions.jsx';
import RolesPermissionsNext from './pages/roles/RolesPermissionsNext.jsx';
import UsersManagement from './pages/users/UsersManagement.jsx';
import UsersManagementNext from './pages/users/UsersManagementNext.jsx';
import RegistrationsList from './pages/registrations/RegistrationsList.jsx';
import RegistrationsListNext from './pages/registrations/RegistrationsListNext.jsx';
import ExamPeriodsList from './pages/examPeriods/ExamPeriodsList.jsx';
import ExamPeriodsListNext from './pages/examPeriods/ExamPeriodsListNext.jsx';
import ExamCitiesList from './pages/examCities/ExamCitiesList.jsx';
import ExamCitiesListNext from './pages/examCities/ExamCitiesListNext.jsx';
import ProfilePage from './pages/profile/ProfilePage.jsx';
import ProfilePageNext from './pages/profile/ProfilePageNext.jsx';
import LabelsPage from './pages/labels/LabelsPage.jsx';
import LabelsPageNext from './pages/labels/LabelsPageNext.jsx';
import PendingRegistrationsList from './pages/pendingRegistrations/PendingRegistrationsList.jsx';
import PendingRegistrationsListNext from './pages/pendingRegistrations/PendingRegistrationsListNext.jsx';
import ExamLibrary from './pages/examLibrary/ExamLibrary.jsx';
import ExamLibraryNext from './pages/examLibrary/ExamLibraryNext.jsx';
import AmericanExams from './pages/americanExams/AmericanExams.jsx';
import AmericanExamsNext from './pages/americanExams/AmericanExamsNext.jsx';
import AmericanExamEditor from './pages/americanExams/AmericanExamEditor.jsx';
import AmericanExamEditorNext from './pages/americanExams/AmericanExamEditorNext.jsx';
import ExamineesList from './pages/examinees/ExamineesList.jsx';
import ExamineesListNext from './pages/examinees/ExamineesListNext.jsx';
import ExamineesReportNext, { ExamineesReportLegacy } from './pages/examinees/ExamineesReportNext.jsx';
import BroadcastsNext, { BroadcastsLegacy } from './pages/broadcasts/BroadcastsNext.jsx';
import GabbaiOrdersSummary from './pages/gabbaiOrders/GabbaiOrdersSummary.jsx';
import GabbaiOrdersSummaryNext from './pages/gabbaiOrders/GabbaiOrdersSummaryNext.jsx';
import StudentPortal from './pages/studentPortal/StudentPortal.jsx';
import GabbaiPortal from './pages/gabbaiPortal/GabbaiPortal.jsx';
import MishtameretLoginPage from './pages/mishtameretPortal/LoginPage.jsx';
import MishtameretRegisterPage from './pages/mishtameretPortal/RegisterPage.jsx';
import MishtameretPortalShell from './pages/mishtameretPortal/PortalShell.jsx';
import MishtameretHomeScreen from './pages/mishtameretPortal/screens/HomeScreen.jsx';
import MishtameretExamsScreen from './pages/mishtameretPortal/screens/ExamsScreen.jsx';
import MishtameretTakeExamScreen from './pages/mishtameretPortal/screens/TakeExamScreen.jsx';
import MishtameretGradesScreen from './pages/mishtameretPortal/screens/GradesScreen.jsx';
import MishtameretScoresScreen from './pages/mishtameretPortal/screens/ScoresScreen.jsx';
import MishtameretLibraryScreen from './pages/mishtameretPortal/screens/LibraryScreen.jsx';
import MishtameretCalendarScreen from './pages/mishtameretPortal/screens/CalendarScreen.jsx';
import MishtameretPhoneTourScreen from './pages/mishtameretPortal/screens/PhoneTourScreen.jsx';
import MishtameretContactScreen from './pages/mishtameretPortal/screens/ContactScreen.jsx';
import NarrationCatalog from './pages/narrationCatalog/NarrationCatalog.jsx';
import GemaraOrders from './pages/gemaraOrders/GemaraOrders.jsx';
import GemaraOrdersNext from './pages/gemaraOrders/GemaraOrdersNext.jsx';
import NarrationCatalogNext from './pages/narrationCatalog/NarrationCatalogNext.jsx';
import IvrExplorer from './pages/ivr/IvrExplorer.jsx';
import IvrExplorerNext from './pages/ivr/IvrExplorerNext.jsx';
import IvrTemplates from './pages/ivrTemplates/IvrTemplates.jsx';
import IvrTemplatesNext from './pages/ivrTemplates/IvrTemplatesNext.jsx';
import ExamAccess from './pages/examAccess/ExamAccess.jsx';
import HomeDashboard from './pages/dashboard/HomeDashboard.jsx';
import HomeDashboardNext from './pages/dashboard/HomeDashboardNext.jsx';
import StudyCalendar from './pages/studyCalendar/StudyCalendar.jsx';
import StudyCalendarLegacy from './pages/studyCalendar/StudyCalendarLegacy.jsx';
import NextRoute from './next/NextRoute.jsx';

const ProtectedRoute = ({ children, resource, action = 'read' }) => {
  const { isAuthenticated, loading, hasPermission, user } = useAuth();
  if (loading) return <div style={{ padding: 24 }}>טוען...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (resource && !hasPermission(resource, action)) {
    // נפילה בטוחה לדף ראשון שיש אליו הרשאה
    if (hasPermission('reports', 'read')) return <Navigate to="/dashboard" replace />;
    if (hasPermission('members', 'read')) return <Navigate to="/members" replace />;
    if (hasPermission('labels', 'read')) return <Navigate to="/labels" replace />;
    return (
      <div style={{ padding: 24 }}>
        אין הרשאה לצפות בדף זה ({user?.username || ''})
      </div>
    );
  }
  return children;
};

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/rimush" element={<StudentPortal />} />
      <Route path="/student" element={<Navigate to="/rimush" replace />} />
      <Route path="/gabbai" element={<GabbaiPortal />} />
      <Route path="/exam/:token" element={<ExamAccess />} />

      <Route path="/mishtameret/login" element={<MishtameretLoginPage />} />
      <Route path="/mishtameret/register" element={<MishtameretRegisterPage />} />
      <Route path="/mishtameret/register/usa" element={<MishtameretRegisterPage region="usa" />} />
      <Route path="/mishtameret/station/login" element={<MishtameretLoginPage />} />
      <Route path="/mishtameret/station" element={<MishtameretPortalShell />}>
        <Route index element={<MishtameretHomeScreen />} />
        <Route path="exams" element={<MishtameretExamsScreen />} />
        <Route path="exams/take/:attemptId" element={<MishtameretTakeExamScreen />} />
        <Route path="grades" element={<MishtameretGradesScreen />} />
        <Route path="scores" element={<MishtameretScoresScreen />} />
        <Route path="calendar" element={<MishtameretCalendarScreen />} />
        <Route path="phone" element={<MishtameretPhoneTourScreen />} />
        <Route path="library" element={<Navigate to="/mishtameret/station/exams?frame=daf_yomi" replace />} />
        <Route path="library/:channelId" element={<Navigate to="/mishtameret/station/exams?frame=daf_yomi" replace />} />
      </Route>
      <Route path="/mishtameret" element={<MishtameretPortalShell />}>
        <Route index element={<MishtameretHomeScreen />} />
        <Route path="exams" element={<MishtameretExamsScreen />} />
        <Route path="exams/take/:attemptId" element={<MishtameretTakeExamScreen />} />
        <Route path="grades" element={<MishtameretGradesScreen />} />
        <Route path="scores" element={<MishtameretScoresScreen />} />
        <Route path="calendar" element={<MishtameretCalendarScreen />} />
        <Route path="phone" element={<MishtameretPhoneTourScreen />} />
        <Route path="contact" element={<MishtameretContactScreen />} />
        <Route path="library" element={<MishtameretLibraryScreen />} />
        <Route path="library/:channelId" element={<MishtameretLibraryScreen />} />
      </Route>

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<ProtectedRoute resource="reports"><NextRoute next={HomeDashboardNext} legacy={HomeDashboard} /></ProtectedRoute>} />
        <Route path="calendar" element={<ProtectedRoute resource="studyCalendar"><NextRoute next={StudyCalendar} legacy={StudyCalendarLegacy} /></ProtectedRoute>} />
        <Route path="members" element={<ProtectedRoute resource="members"><NextRoute next={MembersListNext} legacy={MembersList} /></ProtectedRoute>} />
        <Route path="broadcasts" element={<ProtectedRoute resource="members" action="update"><NextRoute next={BroadcastsNext} legacy={BroadcastsLegacy} /></ProtectedRoute>} />
        <Route path="members/:id" element={<ProtectedRoute resource="members"><NextRoute next={MemberCardNext} legacy={MemberCard} /></ProtectedRoute>} />
        <Route path="exams" element={<ProtectedRoute resource="exams"><NextRoute next={ExamsListNext} legacy={ExamsList} /></ProtectedRoute>} />
        <Route path="exams/:id" element={<ProtectedRoute resource="exams"><NextRoute next={ExamCardNext} legacy={ExamCard} /></ProtectedRoute>} />
        <Route path="kolels" element={<ProtectedRoute resource="kolels"><NextRoute next={KolelsListNext} legacy={KolelsList} /></ProtectedRoute>} />
        <Route path="kolels/:id" element={<ProtectedRoute resource="kolels"><NextRoute next={KolelCardNext} legacy={KolelCard} /></ProtectedRoute>} />
        <Route path="registrations" element={<ProtectedRoute resource="examRegistration"><NextRoute next={RegistrationsListNext} legacy={RegistrationsList} /></ProtectedRoute>} />
        <Route path="exam-periods" element={<ProtectedRoute resource="examPeriod"><NextRoute next={ExamPeriodsListNext} legacy={ExamPeriodsList} /></ProtectedRoute>} />
        <Route path="exam-cities" element={<ProtectedRoute resource="examCity"><NextRoute next={ExamCitiesListNext} legacy={ExamCitiesList} /></ProtectedRoute>} />
        <Route path="pending-registrations" element={<ProtectedRoute resource="members" action="create"><NextRoute next={PendingRegistrationsListNext} legacy={PendingRegistrationsList} /></ProtectedRoute>} />
        <Route path="gabbai-orders" element={<ProtectedRoute resource="exams"><NextRoute next={GabbaiOrdersSummaryNext} legacy={GabbaiOrdersSummary} /></ProtectedRoute>} />
        <Route path="labels" element={<ProtectedRoute resource="labels"><NextRoute next={LabelsPageNext} legacy={LabelsPage} /></ProtectedRoute>} />
        <Route path="exam-library" element={<ProtectedRoute resource="exams"><NextRoute next={ExamLibraryNext} legacy={ExamLibrary} /></ProtectedRoute>} />
        <Route path="american-exams" element={<Navigate to="/american-exams/daf_yomi" replace />} />
        <Route path="american-exams/:frame" element={<ProtectedRoute resource="exams"><NextRoute next={AmericanExamsNext} legacy={AmericanExams} /></ProtectedRoute>} />
        <Route path="american-exams/:frame/:examId" element={<ProtectedRoute resource="exams"><NextRoute next={AmericanExamEditorNext} legacy={AmericanExamEditor} /></ProtectedRoute>} />
        <Route path="examinees" element={<Navigate to="/examinees/daf_yomi" replace />} />
        <Route path="examinees/report" element={<ProtectedRoute resource="grades"><NextRoute next={ExamineesReportNext} legacy={ExamineesReportLegacy} /></ProtectedRoute>} />
        <Route path="examinees/:frame" element={<ProtectedRoute resource="grades"><NextRoute next={ExamineesListNext} legacy={ExamineesList} /></ProtectedRoute>} />
        <Route path="content" element={<ProtectedRoute resource="messages"><NextRoute next={ContentNext} legacy={Content} /></ProtectedRoute>} />
        <Route path="gemara-orders" element={<ProtectedRoute resource="exams"><NextRoute next={GemaraOrdersNext} legacy={GemaraOrders} /></ProtectedRoute>} />
        <Route path="narration-catalog" element={<ProtectedRoute resource="narrationPrompts"><NextRoute next={NarrationCatalogNext} legacy={NarrationCatalog} /></ProtectedRoute>} />
        <Route path="ivr" element={<ProtectedRoute resource="ivr"><NextRoute next={IvrExplorerNext} legacy={IvrExplorer} /></ProtectedRoute>} />
        <Route path="ivr-intro" element={<Navigate to="/ivr-templates?tab=intro" replace />} />
        <Route path="ivr-templates" element={<ProtectedRoute resource="ivr"><NextRoute next={IvrTemplatesNext} legacy={IvrTemplates} /></ProtectedRoute>} />
        <Route path="subscriptions" element={<ProtectedRoute resource="subscriptions"><NextRoute next={SubscriptionsNext} legacy={Subscriptions} /></ProtectedRoute>} />
        <Route path="reports" element={<ProtectedRoute resource="reports"><NextRoute next={ReportsNext} legacy={Reports} /></ProtectedRoute>} />
        <Route path="audit-log" element={<ProtectedRoute resource="auditLogs"><NextRoute next={AuditLogListNext} legacy={AuditLogList} /></ProtectedRoute>} />
        <Route path="feature-flags" element={<ProtectedRoute resource="featureFlags"><NextRoute next={FeatureFlagsNext} legacy={FeatureFlags} /></ProtectedRoute>} />
        <Route path="email-automations" element={<ProtectedRoute resource="emailDomains"><NextRoute next={EmailAutomationsPageNext} legacy={EmailAutomationsPage} /></ProtectedRoute>} />
        <Route path="email-domain" element={<ProtectedRoute resource="emailDomains"><NextRoute next={EmailDomainPageNext} legacy={EmailDomainPage} /></ProtectedRoute>} />
        <Route path="roles" element={<ProtectedRoute resource="roles"><NextRoute next={RolesPermissionsNext} legacy={RolesPermissions} /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute resource="users"><NextRoute next={UsersManagementNext} legacy={UsersManagement} /></ProtectedRoute>} />
        <Route path="profile" element={<NextRoute next={ProfilePageNext} legacy={ProfilePage} />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
